import React from "react";
import { Navigate } from "react-router-dom";
import { useState } from "react";
import { connect } from "react-redux";
import { resetPassword } from "../reducer/Actions";
import hirebeen from '../image/hirebeenLogo.png';
import hide from "../image/icons/hide.png";
import view from "../image/icons/view.png";
import H from '../image/H.png';
import Group1 from '../image/Group1.svg';
import Group2 from '../image/Group2.svg';
import Group3 from '../image/Group3.svg';

const ResetPassword = ({ resetPassword }) => {
    const [ status, setStatus ] = useState (false);
    const [ formData, setFormData ] = useState ({
        email: ""
    });
    const { email } = formData;
    const handlingInput = (e) => setFormData({...formData, [e.target.name]: e.target.value});
    const handlingSubmit = (e) => {
        e.preventDefault();
        resetPassword( email );
        setStatus(true)
    }
    if (status) {
        return <Navigate to={"../"}></Navigate>
    }
    return (
        <div class="grid gap-0 grid-cols-2 max-md:grid-cols-1">
        <div class="w-full h-full  bg-conic-gradient max-md:hidden">
        <div className="flex gap-2.5 self-start max-md:pr-5 mt-6 ml-6">
          <img
            loading="lazy"
            src={H}
            className="shrink-1 aspect-[0.75] w-[29px]"
          />
          <img
            loading="lazy"
            src={hirebeen}
            className="shrink-0 my-auto max-w-full aspect-[5.56] w-[146px]"
          />
        </div>
        <div className=" mx-9 mt-20 text-5xl font-bold text-white leading-[70px] max-md:mt-10 max-md:mr-2.5 max-md:max-w-full max-md:text-4xl max-md:leading-[68px]">
          Build your successful resume instantly using AI
        </div>
        <div className="z-10 self-center mt-3.5 max-w-full w-[574px]">
          <div className="flex gap-1 max-md:flex-col max-md:gap-0">
            <div className="flex flex-col w-11/12 max-md:ml-0 max-md:w-full">
              <div className="flex flex-col grow mt-16 max-md:mt-10">
                <img
                  loading="lazy"
                  src={Group2}
                  className="w-full"
                />
                <img
                  loading="lazy"
                  src={Group3}
                  className="mt-5 w-full"
                />
              </div>
            </div>
            <div className="flex flex-col ml-5 w-11/12 max-md:ml-0 max-md:w-full">
              <div className="flex flex-col max-md:mt-6">
                <img
                  loading="lazy"
                  src={Group1}
                  className="w-full "
                />
                <img
                  loading="lazy"
                  src={Group3}
                  className="mt-5 w-full"
                />
              </div>
            </div>
          </div>
        </div>
        </div>
        <div className="rounded  flex flex-col items-center mt-40 max-md:mt-20">
            <h2 className="text-4xl font-semibold w-80 tracking-tighter leading-10 text-gray-900 max-md:mt-4 max-md:max-w-full">Forgot Password</h2>
            {/* <h5 className="text-center w-80 mb-4 text-gray-400">Please enter your registered email. The link for reset your password will be sent to email</h5> */}
            <form className="mt-4 w-80 mb-3" onSubmit={e => handlingSubmit(e)}>
                <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email:</label>
                    <input name="email" value={email} onChange={e => handlingInput(e)} type="email" className="form-control outline-none w-full py-1 px-4 mt-[-10px] border rounded-md mb-4 text-lg" id="email" placeholder="Enter your registered email"/>
                </div>
                <div className="d-grid gap-2">
                    <button className="outline-none w-full py-1 px-4 rounded-md bg-orange-500 text-center text-white font-semibold hover:bg-orange-300 hover:text-white" type="submit">Send Link</button>
                </div>
            </form>
        </div>
        </div>
    )
}

export default connect(null, { resetPassword })(ResetPassword);